import React from 'react';

const Authorize = () => (
  <div>
    pass access token through url parameter as ?access_token=
  </div>
);

export default Authorize;
